import hero from "../../../images/hero.png";
import "./Hero.css";
import first from "../../../images/middle-left.png";
import second from "../../../images/top-left.png";
import third from "../../../images/top-right.png";
import fourth from "../../../images/middle-right.png";
import fifth from "../../../images/bottom-left.png";
import sixth from "../../../images/bottom-right.png";
function Hero({ clientData }) {
  return (
    <div className="hero">
      <div className="container">
        <div className="hero__container">
          <div className="hero__content">
            <h1 className="hero__title">
              <span
                className="hero__span"
                style={{
                  display: "inline-block",
                  position: "relative",
                  height: "1.05em",
                  minWidth: "150px", // So‘zlar uchun yetarli eni
                  backgroundColor: "#fff", // Mana shu fon doim oq bo‘ladi
                  textAlign: "center", // So‘zlar markazda
                  borderRadius: "5px", // Optional
                  padding: "0 6px",
                  top: "0.25em",
                  paddingTop: "2px",
                  lineHeight: "0.9em",
                  marginBottom: "5px",
                  // bottom: "0.25em",
                }}
              >
                {clientData?.name}
              </span>{" "}
              <br />
              ооооооооооочень <br /> хочет букетик <br /> порадуем ее?
            </h1>
          </div>

          <ul className="hero__list">
            <li className="hero__item">
              <img className="hero__item-img" src={first} alt="first" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={second} alt="second" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={third} alt="third" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={fourth} alt="fourth" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={fifth} alt="fifth" />
            </li>
            <li className="hero__item">
              <img className="hero__item-img" src={sixth} alt="sixth" />
            </li>
          </ul>
        </div>
      </div>

      <img src={hero} className="hero__img" alt="Hero" />
    </div>
  );
}

export default Hero;
